import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Swal from 'sweetalert2';
import Modal from 'react-bootstrap/Modal';
import ReactLoading from 'react-loading';
import PrimaryTable from '../helpers/primary-table'
import { catchError } from '../helpers/catch-error'
import { FaBars, FaPen, FaThumbsUp, FaTrash, FaUsers, FaUser, FaKey, FaUniversalAccess, FaBan, FaPaperclip } from "react-icons/fa";

import { validatePhone, validateAmount, validateEmail } from '../helpers/common'



const Clients = () => {
    const navigate = useNavigate();
    const [clientEdit, setClientEdit] = useState();
    const [clientAdd, setClientAdd] = useState();
    const [addMode, setAddMode] = useState(false);

    const [clientSearch, setClientSearch] = useState(null);
    const [isBtn, setIsBtn] = useState(false)
    const [inputError, setInputError] = useState(false);
    const [clients, setClients] = useState(null);
    const [searchMode, setSearchMode] = useState(false);
    const [editClientModalOpen, setEditClientModalOpen] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [contactAdd, setContactAdd] = useState(null);
    const [contactEdit, setContactEdit] = useState(null);
    const [contactsList, setContactsList] = useState(null);
    const [addContactMode, setAddContactMode] = useState(false);
    const [editContactMode, setEditContactMode] = useState(false);
    const [contactListMode, setContactListMode] = useState(false);
    const [currentClientId, setCurrentClientId] = useState(false);
    const [currentClientLOR, setCurrentClientLOR] = useState(null);

    



    const [lorModalOpen, setLORModalOpen] = useState(false);
    const [lorFile, setLORFile] = useState(null);


    var columns = React.useMemo(
        () => [
            {
                accessorFn: row => <div style={{ width: '220px' }}>
                    <a title="REPORTS" className="btn btn-sm  btn-success me-1" href={"/admin/report-work-orders-client/" + row.client_id} ><FaBars title="REPORTS" /></a>
                    <a title="CASE MANAGERS" className="btn btn-sm btn-success  me-1" href={"/admin/case-managers/" + row.client_id} ><FaUser title="CASE MANAGERS" /></a>
                    <a title="CONTACTS" className="btn btn-sm btn-success  me-1" href="#" onClick={() => { getContacts(row.client_id); setContactListMode(true); }} ><FaUsers title="CONTACTS" /></a>
                    <a title="UPDATE CLIENT" className="btn btn-sm btn-warning me-1 " href="#" onClick={() => editClient(row.client_id)} ><FaPen title="EDIT" /></a>
                    <a title="LOR ATTACHMENT" className="btn btn-sm btn-secondary me-1 " href="#" onClick={() =>{ setLORModalOpen(true); setCurrentClientId(row.client_id); setCurrentClientLOR(row.lor_attachment)}} ><FaPaperclip title="LOR ATTACHMENT" /></a>                
                    <>
                    {row.api_key ?
                        <button title="Remove Key" type="button" className="btn btn-sm btn-danger me-1" onClick={() => removeKey(row.client_id)} ><FaTrash /></button>
                        : <button title="Generate API Key" type="button" className="btn btn-sm  btn-info me-1" onClick={() => generateKey(row.client_id)} ><FaKey /></button>}
                        {row.all_cm_access ? <><button title="Remove Access To All CMs" type="button" className="btn btn-sm btn-danger" onClick={() => removeAccess(row.client_id)} ><FaBan /></button></>
                            : <button title="Grant Access To All CMs" type="button" className="btn btn-sm  btn-info" onClick={() => grantAccess(row.client_id)} ><FaUniversalAccess /></button>
                        }
                        </>
                </div>,
                id: "actions",
                cell: info => info.getValue(),
                header: () => "ACTIONS",
                footer: props => props.column.id,
                enableColumnFilter: false,
                enableSorting: false,

            },
            {
                accessorKey: "client_id",
                header: () => "ID",
                footer: props => props.column.id,
                enableColumnFilter: false,

            },
            {
                accessorKey: "client_company_name",
                header: () => "Name",
                footer: props => props.column.id
            },
            {
                accessorFn: row => row.client_address + ", " + row.client_city + ", " + row.client_state + ", " + row.client_zip,
                id: "address",
                cell: info => info.getValue(),
                header: () => "ADDRESS",
                footer: props => props.column.id
            },
            {
                accessorFn: row => row.client_phone,
                id: "phone",
                cell: info => info.getValue(),
                header: () => "PHONE",
                footer: props => props.column.id
            },
            {
                accessorKey: "client_contact_name",
                header: "CONTACT",
                footer: props => props.column.id
            }
            ,
            {
                accessorKey: "api_key",
                header: "KEY",
                footer: props => props.column.id,
                enableColumnFilter: false,
                enableSorting: false,
            },
            {
                accessorFn: row => row.status == 1 ? "ACTIVE" : "BLOCKED",
                id: "status",
                cell: info => info.getValue(),
                header: () => "STATUS",
                footer: props => props.column.id,
                enableColumnFilter: false,
            },

        ],
        []
    )




    useEffect(() => {

        getClients();

    }, []);




    const getClients = async () => {
        setIsLoading(true);
        setClientEdit(null);
        axios.get(process.env.REACT_APP_WEB_SERVICES_URL + "/admin/get-clients/", {
            headers: {
                'Content-Type': 'application/json'
            },
            withCredentials: true
        }).then(function (response) {

            if (response?.data?.status) {

                setClients(response?.data?.clients);
                setIsLoading(false);

            } else {

                Swal.fire({ icon: "error", title: "Client Info", text: response?.data?.message });

            }
        }).catch(function (error) {

            catchError(error, navigate)
        });

    }




    const editClient = async (client_id) => {

        setClientEdit(null);
        setIsLoading(true);
        setEditClientModalOpen(true);
        axios.get(process.env.REACT_APP_WEB_SERVICES_URL + "/admin/get-client-by-id/" + client_id, {
            headers: {
                'Content-Type': 'application/json'
            },
            withCredentials: true
        }).then(function (response) {
            setIsLoading(false);
            if (response?.data?.status) {


                setClientEdit(response?.data?.client);


            } else {

                Swal.fire({ icon: "error", title: "Client Info", text: response?.data?.message });
                setEditClientModalOpen(false);

            }
        }).catch(function (error) {
            setIsLoading(false);
            setEditClientModalOpen(false);
            catchError(error, navigate)
        });

    }



    const saveClient = async (e) => {

        setIsBtn(true);

        if (!clientAdd) {
            setInputError(true);
            setIsBtn(false);
            return false;
        }
        const { client_company_name, client_address, client_city, client_state, client_zip, client_fee, client_fee_limit, first_name, last_name, email, phone, fax } = clientAdd;
        if (!client_company_name || !client_address || !client_city || !client_state || !client_zip || !first_name || !last_name || !email || !phone
            || !validateAmount(client_fee) || !validateAmount(client_fee_limit) || !validatePhone(phone) || !validatePhone(fax)
            || !validateEmail(email)) {
            setInputError(true);
            setIsBtn(false);

        } else {

            var client_info = {
                client_company_name: clientAdd?.client_company_name,
                client_address: clientAdd?.client_address,
                client_city: clientAdd?.client_city,
                client_state: clientAdd?.client_state,
                client_zip: clientAdd?.client_zip,
                client_fee: clientAdd?.client_fee,
                client_fee_limit: clientAdd?.client_fee_limit,
                client_receipt_type: clientAdd?.client_receipt_type ? clientAdd?.client_receipt_type : 0,
                client_internal_notes: clientAdd?.client_internal_notes,
                first_name: clientAdd?.first_name,
                last_name: clientAdd?.last_name,
                email: clientAdd?.email,
                phone: clientAdd?.phone,
                fax: clientAdd?.fax,
                email_opt_in: clientAdd?.email_opt_in ? clientAdd?.email_opt_in : 0,

            }
            axios.post(process.env.REACT_APP_WEB_SERVICES_URL + "/admin/add-client", client_info, {
                headers: {
                    'Content-Type': 'application/json'
                },
                withCredentials: true
            }).then(async function (response) {

                if (response?.data?.status) {

                    setAddMode(false)
                    getClients(client_info);
                    setIsBtn(false)
                    Swal.fire({ icon: "success", title: "Client Add", text: "New client has been added successfully." });

                } else {
                    Swal.fire({ icon: "error", title: "Client Info", text: response?.data?.message });
                    setIsBtn(false)
                }
            }).catch(function (error) {

                setIsBtn(false);
                catchError(error, navigate)
            });

        }
    }


    const updateClient = async (e) => {

        setIsBtn(true);

        const { client_company_name, client_address, client_city, client_state, client_zip, client_fee, client_fee_limit } = clientEdit;
        if (!client_company_name || !client_address || !client_city || !client_state || !client_zip || !validateAmount(client_fee) || !validateAmount(client_fee_limit)) {


            setInputError(true);
            setIsBtn(false);

        } else {

            var client_info = {
                client_id: clientEdit?.client_id,
                client_company_name: clientEdit?.client_company_name,
                client_address: clientEdit?.client_address,
                client_city: clientEdit?.client_city,
                client_state: clientEdit?.client_state,
                client_zip: clientEdit?.client_zip,
                client_fee: clientEdit?.client_fee,
                client_fee_limit: clientEdit?.client_fee_limit,
                client_receipt_type: clientEdit?.client_receipt_type,
                client_internal_notes: clientEdit?.client_internal_notes,
                status: clientEdit?.status,
            }
            axios.post(process.env.REACT_APP_WEB_SERVICES_URL + "/admin/update-client", client_info, {
                headers: {
                    'Content-Type': 'application/json'
                },
                withCredentials: true
            }).then(async function (response) {

                if (response?.data?.status) {

                    setAddMode(false)
                    setEditClientModalOpen(false);
                    setIsBtn(false)
                    Swal.fire({ icon: "success", title: "Client Update", text: "Client has been updated successfully." });
                    getClients(client_info);


                } else {
                    Swal.fire({ icon: "error", title: "Client Info", text: response?.data?.message });

                }
                setIsBtn(false)

            }).catch(function (error) {
                setIsBtn(false);
                catchError(error, navigate)
            });

        }


    }



    const searchClients = () => {

        setIsBtn(true);
        var search_elements = {}
        search_elements.client_company_name = clientSearch?.client_company_name;
        search_elements.client_address = clientSearch?.client_address;
        search_elements.client_city = clientSearch?.client_city;
        search_elements.client_state = clientSearch?.client_state;
        search_elements.limit = 200;


        axios.post(process.env.REACT_APP_WEB_SERVICES_URL + "/admin/search-clients", search_elements, {
            headers: {
                'Content-Type': 'application/json'
            },
            withCredentials: true
        }).then(function (response) {

            if (response?.data?.status) {

                setClients(response?.data?.clients);

            }
            else {
                setClients(null);

            }
            setIsBtn(false);

        }).catch(function (error) {

            setIsBtn(false);
            catchError(error, navigate)

        });


    }


    const resetSearchClients = () => {

        setSearchMode(false);
        setClientSearch(null);
        getClients();
    }



    const resetAddClient = () => {

        setAddMode(false);
        setClientAdd(null);
    }


    const resetEditClients = () => {

        setEditClientModalOpen(false);
        getClients();
    }



    const removeKey = async (client_id) => {

        var client_info = {
            client_id: client_id,
        }
        axios.post(process.env.REACT_APP_WEB_SERVICES_URL + "/admin/remove-api-key", client_info, {
            headers: {
                'Content-Type': 'application/json'
            },
            withCredentials: true
        }).then(async function (response) {

            if (response?.data?.status) {

                Swal.fire({ icon: "success", title: "Client Update", text: "Key removed successfully." });
                getClients(client_info);


            } else {
                Swal.fire({ icon: "error", title: "Client Info", text: response?.data?.message });

            }
            setIsBtn(false)

        }).catch(function (error) {


            setIsBtn(false);
            catchError(error, navigate)
        });

    }




    const generateKey = async (client_id) => {


        var client_info = {
            client_id: client_id,
        }
        axios.post(process.env.REACT_APP_WEB_SERVICES_URL + "/admin/generate-api-key", client_info, {
            headers: {
                'Content-Type': 'application/json'
            },
            withCredentials: true
        }).then(async function (response) {

            if (response?.data?.status) {


                Swal.fire({ icon: "success", title: "Client Update", text: "Key generated successfully." });
                getClients(client_info);


            } else {
                Swal.fire({ icon: "error", title: "Client Info", text: response?.data?.message });

            }
            setIsBtn(false)

        }).catch(function (error) {


            setIsBtn(false);
            catchError(error, navigate)
        });

    }



    const getContacts = async (c) => {


        axios.get(process.env.REACT_APP_WEB_SERVICES_URL + "/admin/get-contacts-by-client/" + c, {
            headers: {
                'Content-Type': 'application/json'
            },
            withCredentials: true
        }).then(function (response) {

            if (response?.data?.status) {

                setContactsList(response?.data?.contacts);
                setCurrentClientId(c);

            } else {

                Swal.fire({ icon: "error", title: "Client Info", text: response?.data?.message });

            }
        }).catch(function (error) {

            catchError(error, navigate)

        });

    }


    const saveContact = async () => {

        setIsBtn(true);
        const { first_name, last_name, email, phone } = contactAdd;
        if (!first_name || !last_name || !email || !phone || !validateEmail(email) || !validatePhone(phone)) {

            setInputError(true);
            setIsBtn(false);

        } else {

            var contact_info = {
                client_id: currentClientId,
                first_name: contactAdd.first_name,
                last_name: contactAdd.last_name,
                email: contactAdd.email,
                phone: contactAdd.phone,
                fax: contactAdd.fax,
                email_opt_in: contactAdd.email_opt_in,

            }
            axios.post(process.env.REACT_APP_WEB_SERVICES_URL + "/admin/add-contact", contact_info, {
                headers: {
                    'Content-Type': 'application/json'
                },
                withCredentials: true
            }).then(async function (response) {

                if (response?.data?.status) {

                    setAddContactMode(false);
                    setEditContactMode(false);
                    getContacts(currentClientId);
                    setIsBtn(false)
                } else {
                    Swal.fire({ icon: "error", title: "Case Manager ", text: response?.data?.message });
                    setIsBtn(false)
                }
            }).catch(function (error) {

                setIsBtn(false);
                catchError(error, navigate)

            });

        }
    }



    const updateContact = async () => {

        setIsBtn(true);
        const { first_name, last_name, email, phone } = contactEdit;
        if (!first_name || !last_name || !email || !validateEmail(email) || !validatePhone(phone)) {

            setInputError(true);
            setIsBtn(false);

        } else {

            var contact_info = {
                id: contactEdit.id,
                client_id: contactEdit.client_id,
                first_name: contactEdit.first_name,
                last_name: contactEdit.last_name,
                email: contactEdit.email,
                phone: contactEdit.phone,
                fax: contactEdit.fax,
                email_opt_in: contactEdit.email_opt_in,

            }
            axios.post(process.env.REACT_APP_WEB_SERVICES_URL + "/admin/update-contact", contact_info, {
                headers: {
                    'Content-Type': 'application/json'
                },
                withCredentials: true
            }).then(async function (response) {

                if (response?.data?.status) {

                    setAddContactMode(false);
                    setEditContactMode(false);
                    getContacts(contactEdit.client_id);
                    setContactEdit(null)
                    setIsBtn(false)

                } else {
                    Swal.fire({ icon: "error", title: "Contact ", text: response?.data?.message });
                    setIsBtn(false)
                }
            }).catch(function (error) {

                setIsBtn(false);
                catchError(error, navigate)

            });

        }
    }


    const editContact = async (c) => {

        setEditContactMode(true);
        setContactEdit({
            id: c.id,
            client_id: c.client_id,
            first_name: c.first_name,
            last_name: c.last_name,
            email: c.email,
            fax: c.fax,
            phone: c.phone,
            email_opt_in: c.email_opt_in,
        })

    }



    const deactivateContact = async (id) => {

        setIsBtn(true);
        axios.post(process.env.REACT_APP_WEB_SERVICES_URL + "/admin/deactivate-contact", { id: id }, {
            headers: {
                'Content-Type': 'application/json'
            },
            withCredentials: true
        }).then(async function (response) {

            if (response?.data?.status) {

                getContacts(currentClientId);

                setIsBtn(false)
            } else {
                Swal.fire({ icon: "error", title: "Client Info", text: response?.data?.message });
                setIsBtn(false)
            }
        }).catch(function (error) {

            setIsBtn(false);
            catchError(error, navigate)

        });

    }



    const activateContact = async (id) => {

        setIsBtn(true);
        axios.post(process.env.REACT_APP_WEB_SERVICES_URL + "/admin/activate-contact", { id: id }, {
            headers: {
                'Content-Type': 'application/json'
            },
            withCredentials: true
        }).then(async function (response) {

            if (response?.data?.status) {

                getContacts(currentClientId);

                setIsBtn(false)
            } else {
                Swal.fire({ icon: "error", title: "Client Info", text: response?.data?.message });
                setIsBtn(false)
            }
        }).catch(function (error) {

            setIsBtn(false);
            catchError(error, navigate)

        });

    }



    const resetContactAdd = () => {

        setContactAdd({
            id: "",
            client_id: currentClientId,
            first_name: "",
            last_name: "",
            email: "",
            fax: "",
            phone: "",
            email_opt_in: 1,
        })

    }






    const removeAccess = async (client_id) => {

        var client_info = {
            client_id: client_id,
        }
        axios.post(process.env.REACT_APP_WEB_SERVICES_URL + "/admin/remove-access-to-all-case-managers", client_info, {
            headers: {
                'Content-Type': 'application/json'
            },
            withCredentials: true
        }).then(async function (response) {

            if (response?.data?.status) {

                Swal.fire({ icon: "success", title: "Access Update", text: "All case manager access removed successfully." });
                getClients(client_info);


            } else {
                Swal.fire({ icon: "error", title: "Case Manager Access", text: response?.data?.message });

            }
            setIsBtn(false)

        }).catch(function (error) {


            setIsBtn(false);
            catchError(error, navigate)
        });

    }




    const grantAccess = async (client_id) => {


        var client_info = {
            client_id: client_id,
        }
        axios.post(process.env.REACT_APP_WEB_SERVICES_URL + "/admin/grant-access-to-all-case-managers", client_info, {
            headers: {
                'Content-Type': 'application/json'
            },
            withCredentials: true
        }).then(async function (response) {

            if (response?.data?.status) {


                Swal.fire({ icon: "success", title: "Case manager Access", text: "Access granted to all case managers successfully." });
                getClients(client_info);


            } else {
                Swal.fire({ icon: "error", title: "Case Manager Access", text: response?.data?.message });

            }
            setIsBtn(false)

        }).catch(function (error) {


            setIsBtn(false);
            catchError(error, navigate)
        });

    }





    const uploadLOR = async (client_id) => {
        if (!lorFile) {
            Swal.fire({ icon: "warning", title: "LOR", text: "Please select a PDF file." });
            return;
        }

        setIsBtn(true);

        const formData = new FormData();
        formData.append("lor_attachment", lorFile);
        formData.append("client_id", client_id);

        axios.post(
            process.env.REACT_APP_WEB_SERVICES_URL + "/admin/upload-lor",
            formData,
            {
                headers: { "Content-Type": "multipart/form-data" },
                withCredentials: true
            }
        )
            .then(response => {
                if (response?.data?.status) {
                    Swal.fire({ icon: "success", title: "Uploaded", text: "LOR uploaded successfully!" });
                    setLORFile(null);
                } else {
                    Swal.fire({ icon: "error", title: "Upload Error", text: response?.data?.message });
                }
                getClients();
                setIsBtn(false);
            })
            .catch(error => {
                setIsBtn(false);
                catchError(error, navigate);
            });
    };

    const removeLOR = async () => {
        setIsBtn(true);

        axios.post(
            process.env.REACT_APP_WEB_SERVICES_URL + "/admin/delete-lor",
            { client_id: currentClientId },
            {
                headers: { "Content-Type": "application/json" },
                withCredentials: true
            }
        )
            .then(response => {
                if (response?.data?.status) {
                    Swal.fire({ icon: "success", title: "Deleted", text: "LOR removed!" });
                    setLORModalOpen(false);
                } else {
                    Swal.fire({ icon: "error", title: "Error", text: response?.data?.message });
                }
                getClients();
                setIsBtn(false);
            })
            .catch(error => {
                setIsBtn(false);
                catchError(error, navigate);
            });
    };


    return (
        <>



            <div className="row mx-3 pb-2 mt-4">
                <div className="col-md-4 col-sm-12 ps-3 ">
                    <h3 className="text-dark my-0">CLIENTS</h3>
                </div>

                <div className="col-md-8 col-sm-12 text-md-end -2">
                    {!searchMode && !addMode &&
                        <>
                            <button onClick={() => { setSearchMode(true); setClientSearch(null) }} className="btn btn-success me-1">SEARCH</button>
                            <button onClick={() => { setAddMode(true); setClientAdd(null); }} className="btn btn-warning">ADD NEW</button>
                        </>
                    }
                </div>
            </div>

            {(addMode) &&

                <div className="card card-form card-primary mb-3 mx-3">
                    <div className="card-heading px-3 py-3"><h6 className="fw-bold my-0">ADD NEW CLIENT</h6></div>
                    <div className="card-body">

                        <>

                            <div className="row px-3 py-2 gx-2 ">

                                <div className="col-3 my-2">
                                    <label htmlFor="client_company_name" >Company Name*</label>

                                    <input name="client_company_name" className="form-control"
                                        value={clientAdd?.client_company_name}
                                        onChange={(e) =>
                                            setClientAdd({ ...clientAdd, client_company_name: e.target.value })
                                        }


                                    />

                                    {inputError && !clientAdd?.client_company_name &&
                                        <span className="text-danger">Enter company Name</span>
                                    }




                                </div>

                                <div className="col-3 my-2">
                                    <label htmlFor="client_address">ADDRESS*</label>
                                    <input name="client_address" id="client_address" type="text" className="form-control"
                                        value={clientAdd?.client_address}
                                        onChange={(e) =>
                                            setClientAdd({ ...clientAdd, client_address: e.target.value })
                                        }

                                    />
                                    {inputError && !clientAdd?.client_address &&
                                        <span className="text-danger">Enter address</span>
                                    }


                                </div>

                                <div className="col-3 my-2">
                                    <label htmlFor="client_city">CITY*</label>

                                    <input name="client_city" id="client_city" type="text" className="form-control"
                                        value={clientAdd?.client_city}
                                        onChange={(e) =>
                                            setClientAdd({ ...clientAdd, client_city: e.target.value })
                                        }

                                    />

                                    {inputError && !clientAdd?.client_city &&
                                        <span className="text-danger">Enter city</span>
                                    }

                                </div>

                                <div className="col-3 my-2">
                                    <div className="row gx-2">

                                        <div className="col-6">
                                            <label htmlFor="client_state">STATE*</label>

                                            <input name="client_state" id="client_state" type="text"
                                                className="form-control"
                                                value={clientAdd?.client_state} onChange={(e) =>
                                                    setClientAdd({ ...clientAdd, client_state: e.target.value })
                                                }
                                            />
                                            {inputError && !clientAdd?.client_state &&
                                                <span className="text-danger">Enter state</span>
                                            }

                                        </div>
                                        <div className="col-6">


                                            <label htmlFor="client_zip">ZIP*</label>

                                            <input name="client_zip" id="client_zip" type="text"
                                                className="form-control"
                                                value={clientAdd?.client_zip} onChange={(e) =>
                                                    setClientAdd({ ...clientAdd, client_zip: e.target.value })
                                                }
                                            />

                                            {inputError && !clientAdd?.client_zip &&
                                                <span className="text-danger">Enter zip</span>
                                            }
                                        </div>
                                    </div>
                                </div>

                            </div>



                            <div className="row px-3 py-1 gx-2 ">

                                <div className="col-2 my-2">
                                    <label htmlFor="client_fee_limit">FEE LIMIT:(dd.cc)$</label>

                                    <input name="client_fee_limit" id="client_fee_limit" type="text" className="form-control"
                                        value={clientAdd?.client_fee_limit} onChange={(e) =>
                                            setClientAdd({ ...clientAdd, client_fee_limit: e.target.value })
                                        }

                                    />

                                    {inputError && !validateAmount(clientAdd?.client_fee_limit) && (
                                        <span className="text-danger">Enter valid fee limit</span>
                                    )}


                                </div>

                                <div className="col-2 my-2">
                                    <label htmlFor="client_fee">CLIENT FEE:(dd.cc)$</label>

                                    <input name="client_fee" id="client_fee" type="text" className="form-control"
                                        value={clientAdd?.client_fee} onChange={(e) =>
                                            setClientAdd({ ...clientAdd, client_fee: e.target.value })
                                        }

                                    />

                                    {inputError && !validateAmount(clientAdd?.client_fee) && (
                                        <span className="text-danger">Enter valid fee</span>
                                    )}

                                </div>

                                <div className="col-2 my-2">
                                    <label htmlFor="client_receipt_type">Receipt Type:</label>
                                    <div className="form-control py-2 border-2 border-dark px-1">

                                        <input type="radio" className="form-check-input me-1" name="client_receipt_type" value="1"
                                            onClick={() => setClientAdd({ ...clientAdd, client_receipt_type: 1 })} checked={(clientAdd?.client_receipt_type == 1) ? "true" : ""} />Ledger
                                        <input type="radio" className="form-check-input ms-2 me-1" name="client_receipt_type" value="0"
                                            onClick={() => setClientAdd({ ...clientAdd, client_receipt_type: 0 })} checked={(clientAdd?.client_receipt_type == 0) ? "true" : ""} />Invoice
                                    </div>

                                </div>





                                <div className="col-6 py-2">
                                    <label htmlFor="client_internal_notes">INTERNAL NOTES</label>

                                    <textarea rows="1" name="client_internal_notes" id="client_internal_notes"
                                        className="form-control"
                                        onChange={(e) =>
                                            setClientAdd({ ...clientAdd, client_internal_notes: e.target.value })
                                        }
                                        value={clientAdd?.client_internal_notes}

                                    >
                                        {clientAdd?.client_internal_notes}
                                    </textarea>

                                </div>
                            </div>

                            <div className="row px-3 py-1 gx-2 ">

                                <div className="col-2 my-3">
                                    <label htmlFor="first_name">Contact First Name</label>

                                    <input name="first_name" id="first_name" type="text" className="form-control"
                                        value={clientAdd?.first_name}
                                        onChange={(e) =>
                                            setClientAdd({ ...clientAdd, first_name: e.target.value })
                                        }

                                    />

                                    {inputError && !clientAdd?.first_name &&
                                        <span className="text-danger">Enter First name</span>
                                    }

                                </div>
                                <div className="col-2 my-3">
                                    <label htmlFor="last_name">Contact Last Name</label>

                                    <input name="last_name" id="last_name" type="text" className="form-control"
                                        value={clientAdd?.last_name}
                                        onChange={(e) =>
                                            setClientAdd({ ...clientAdd, last_name: e.target.value })
                                        }

                                    />

                                    {inputError && !clientAdd?.last_name &&
                                        <span className="text-danger">Enter Last Name</span>
                                    }

                                </div>
                                <div className="col-2 my-3">
                                    <label htmlFor="email">Contact Email</label>

                                    <input name="email" id="email" type="text" className="form-control"
                                        value={clientAdd?.email}
                                        onChange={(e) =>
                                            setClientAdd({ ...clientAdd, email: e.target.value })
                                        }

                                    />

                                    {inputError && (!clientAdd?.email || !validateEmail(clientAdd?.email)) &&
                                        <span className="text-danger">Enter valid email</span>
                                    }

                                </div>
                                <div className="col-2 my-3">
                                    <label htmlFor="phone">Contact Phone</label>

                                    <input name="phone" id="phone" type="text" className="form-control"
                                        value={clientAdd?.phone}
                                        onChange={(e) =>
                                            setClientAdd({ ...clientAdd, phone: e.target.value })
                                        }

                                    />

                                    {inputError && (!clientAdd?.phone || !validatePhone(clientAdd?.phone)) && (
                                        <span className="text-danger">Enter phone in xxx-xxx-xxxx format</span>
                                    )}



                                </div>
                                <div className="col-2 my-3">
                                    <label htmlFor="fax">Contact Fax</label>

                                    <input name="fax" id="fax" type="text" className="form-control"
                                        value={clientAdd?.fax}
                                        onChange={(e) =>
                                            setClientAdd({ ...clientAdd, fax: e.target.value })
                                        }

                                    />

                                    {inputError && clientAdd?.fax && !validatePhone(clientAdd?.fax) && (
                                        <span className="text-danger">Enter fax in xxx-xxx-xxxx format</span>
                                    )}


                                </div>

                                <div className="col-2 my-3">
                                    <label htmlFor="email_opt_in" >Contact Email Opt-In</label>
                                    <div className="form-control py-2 border-2 border-dark">

                                        <input type="radio" className="form-check-input " name="email_opt_in" value="1"
                                            onClick={() => setClientAdd({ ...clientAdd, email_opt_in: 1 })} checked={(clientAdd?.email_opt_in == 1) ? "true" : ""} /> Yes
                                        <input type="radio" className="form-check-input ms-3" name="email_opt_in" value="0"
                                            onClick={() => setClientAdd({ ...clientAdd, email_opt_in: 0 })} checked={(clientAdd?.email_opt_in == 0) ? "true" : ""} /> No

                                    </div>
                                </div>

                            </div>

                        </>


                    </div>
                    <div className="card-footer">
                        <div className="row">
                            <div className="col-xl-12 col-lg-12 col-sm-12 text-center">
                                <button onClick={() => saveClient()} className="btn btn-success me-1 mt-1" type="button" disabled={isBtn ? true : false} >{isBtn ? <><div className="spinner-border spinner-border-sm me-1" role="status"></div><span className="sr-only">Loading...</span></> : "SAVE"}</button>
                                <button onClick={() => { resetAddClient(); }} className="btn btn-warning me-1 mt-1" type="button">CANCEL SAVE</button>

                            </div>
                        </div>
                    </div>

                </div>
            }


            {searchMode &&
                <>


                    <div className="card card-form card-primary mb-3 mx-3">
                        <div className="card-heading px-3 py-2"><h6 className="fw-bold my-0">SEARCH CLIENT</h6></div>
                        <div className="card-body">
                            <form className="form-horizontal form-thick mb-3"  >

                                <div className="row ">
                                    <div className="col-3">
                                        <label htmlFor="client_company_name" >Client</label>
                                        <input name="client_company_name" className="form-control" type="text"
                                            value={clientSearch?.client_company_name}
                                            onChange={(e) =>
                                                setClientSearch({ ...clientSearch, client_company_name: e.target.value })
                                            }

                                        />


                                    </div>



                                    <div className="col-3">
                                        <label htmlFor="client_address">Address</label>
                                        <input name="client_address" id="client_address" type="text" className="form-control"
                                            value={clientSearch?.client_address}
                                            onChange={(e) =>
                                                setClientSearch({ ...clientSearch, client_address: e.target.value })
                                            }

                                        />
                                    </div>

                                    <div className="col-3">
                                        <label htmlFor="client_city">City</label>
                                        <input name="client_city" id="client_city" type="text" className="form-control"
                                            value={clientSearch?.client_city}
                                            onChange={(e) =>
                                                setClientSearch({ ...clientSearch, client_city: e.target.value })
                                            }

                                        />

                                    </div>

                                    <div className="col-3">
                                        <label htmlFor="client_state">State</label>
                                        <input name="client_state" id="client_state" type="text" className="form-control"
                                            value={clientSearch?.client_state}
                                            onChange={(e) =>
                                                setClientSearch({ ...clientSearch, client_state: e.target.value })
                                            }

                                        />

                                    </div>





                                </div>


                            </form>
                        </div>
                        <div className="card-footer">


                            <div className="container text-center">

                                <button type='button' onClick={() => searchClients()} className="btn btn-success me-1" disabled={isBtn}>
                                    {isBtn ? <><div className="spinner-border spinner-border-sm me-1" role="status">

                                    </div><span className="sr-only">Loading...</span></> : 'Search'}
                                </button>
                                <button type='button' className="btn btn-warning" onClick={(e) => resetSearchClients()}  >Cancel</button>
                            </div>


                        </div>

                    </div>


                </>
            }
            {contactListMode &&

                <div className="card card-form card-primary mb-3 mx-3">
                    <div className="card-heading px-3 py-3">
                        <div className="row sub-heading">

                            <div className="col fw-bold my-0  ">CLIENT CONTACTS</div>
                            <div className="col text-end ">

                                {addContactMode ?
                                    <>
                                        <button onClick={() => saveContact()} className="btn btn-sm btn-sm btn-success me-1 " type="button" disabled={isBtn ? true : false} >{isBtn ? <><div className="spinner-border spinner-border-sm me-1" role="status"></div><span className="sr-only">Loading...</span></> : "SAVE"}</button>
                                        <button onClick={() => setAddContactMode(false)} className="btn btn-sm btn-sm btn-warning me-1 " type="button">CANCEL SAVE</button>

                                    </>
                                    :
                                    <>
                                        {editContactMode ?
                                            <>
                                                <button onClick={() => updateContact()} className="btn btn-sm btn-sm btn-success me-1 " type="button" disabled={isBtn ? true : false} >{isBtn ? <><div className="spinner-border spinner-border-sm me-1" role="status"></div><span className="sr-only">Loading...</span></> : "UPDATE"}</button>
                                                <button onClick={() => setEditContactMode(false)} className="btn btn-sm btn-sm btn-warning me-1 " type="button">CANCEL UPDATE</button>

                                            </>
                                            :
                                            <>
                                                <button onClick={() => { resetContactAdd(); setAddContactMode(true); setInputError(false); }} className="btn btn-sm btn-sm btn-success me-1 " type="button">NEW CONTACT</button>
                                                <button onClick={() => { setContactListMode(false); setCurrentClientId(null); setEditContactMode(false); setAddContactMode(false); }} className="btn btn-sm btn-sm btn-warning me-1 " type="button">CLOSE CONTACT</button>

                                            </>
                                        }
                                    </>
                                }

                            </div>
                        </div>
                    </div>
                    <div className="card-body">



                        {(addContactMode) &&
                            <div className="row px-3 py-1 gx-2 ">

                                <div className="col-2 my-3">
                                    <label htmlFor="first_name">Contact First Name</label>

                                    <input name="first_name" id="first_name" type="text" className="form-control"
                                        value={contactAdd?.first_name}
                                        onChange={(e) =>
                                            setContactAdd({ ...contactAdd, first_name: e.target.value })
                                        }

                                    />

                                    {inputError && !contactAdd?.first_name &&
                                        <span className="text-danger">Enter First name</span>
                                    }

                                </div>
                                <div className="col-2 my-3">
                                    <label htmlFor="last_name">Contact Last Name</label>

                                    <input name="last_name" id="last_name" type="text" className="form-control"
                                        value={contactAdd?.last_name}
                                        onChange={(e) =>
                                            setContactAdd({ ...contactAdd, last_name: e.target.value })
                                        }

                                    />

                                    {inputError && !contactAdd?.last_name &&
                                        <span className="text-danger">Enter Last Name</span>
                                    }

                                </div>
                                <div className="col-2 my-3">
                                    <label htmlFor="email">Contact Email</label>

                                    <input name="email" id="email" type="text" className="form-control"
                                        value={contactAdd?.email}
                                        onChange={(e) =>
                                            setContactAdd({ ...contactAdd, email: e.target.value })
                                        }

                                    />

                                    {inputError && (!contactAdd?.email || !validateEmail(contactAdd?.email)) &&
                                        <span className="text-danger">Enter valid email</span>
                                    }

                                </div>
                                <div className="col-2 my-3">
                                    <label htmlFor="phone">Contact Phone</label>

                                    <input name="phone" id="phone" type="text" className="form-control"
                                        value={contactAdd?.phone}
                                        onChange={(e) =>
                                            setContactAdd({ ...contactAdd, phone: e.target.value })
                                        }

                                    />

                                    {inputError && (!contactAdd?.phone || !validatePhone(contactAdd?.phone)) && (
                                        <span className="text-danger">Enter phone in xxx-xxx-xxxx format</span>
                                    )}



                                </div>
                                <div className="col-2 my-3">
                                    <label htmlFor="fax">Contact Fax</label>

                                    <input name="fax" id="fax" type="text" className="form-control"
                                        value={contactAdd?.fax}
                                        onChange={(e) =>
                                            setContactAdd({ ...contactAdd, fax: e.target.value })
                                        }

                                    />

                                    {inputError && contactAdd?.fax && !validatePhone(contactAdd?.fax) && (
                                        <span className="text-danger">Enter fax in xxx-xxx-xxxx format</span>
                                    )}


                                </div>

                                <div className="col-2 my-3">
                                    <label htmlFor="email_opt_in" >Contact Email Opt-In</label>
                                    <div className="form-control py-2 border-2 border-dark">

                                        <input type="radio" className="form-check-input " name="email_opt_in" value="1"
                                            onClick={() => setContactAdd({ ...contactAdd, email_opt_in: 1 })} checked={(contactAdd?.email_opt_in == 1) ? "true" : ""} /> Yes
                                        <input type="radio" className="form-check-input ms-3" name="email_opt_in" value="0"
                                            onClick={() => setContactAdd({ ...contactAdd, email_opt_in: 0 })} checked={(contactAdd?.email_opt_in == 0) ? "true" : ""} /> No

                                    </div>
                                </div>

                            </div>
                        }
                        {(editContactMode) &&
                            <div className="row px-3 py-1 gx-2 ">

                                <div className="col-2 my-3">
                                    <label htmlFor="first_name">Contact First Name</label>

                                    <input name="first_name" id="first_name" type="text" className="form-control"
                                        value={contactEdit?.first_name}
                                        onChange={(e) =>
                                            setContactEdit({ ...contactEdit, first_name: e.target.value })
                                        }

                                    />

                                    {inputError && !contactEdit?.first_name &&
                                        <span className="text-danger">Enter First name</span>
                                    }

                                </div>
                                <div className="col-2 my-3">
                                    <label htmlFor="last_name">Contact Last Name</label>

                                    <input name="last_name" id="last_name" type="text" className="form-control"
                                        value={contactEdit?.last_name}
                                        onChange={(e) =>
                                            setContactEdit({ ...contactEdit, last_name: e.target.value })
                                        }

                                    />

                                    {inputError && !contactEdit?.last_name &&
                                        <span className="text-danger">Enter Last Name</span>
                                    }

                                </div>
                                <div className="col-2 my-3">
                                    <label htmlFor="email">Contact Email</label>

                                    <input name="email" id="email" type="text" className="form-control"
                                        value={contactEdit?.email}
                                        onChange={(e) =>
                                            setContactEdit({ ...contactEdit, email: e.target.value })
                                        }

                                    />

                                    {inputError && (!contactEdit?.email || !validateEmail(contactEdit?.email)) &&
                                        <span className="text-danger">Enter Email</span>
                                    }

                                </div>
                                <div className="col-2 my-3">
                                    <label htmlFor="phone">Contact Phone</label>

                                    <input name="phone" id="phone" type="text" className="form-control"
                                        value={contactEdit?.phone}
                                        onChange={(e) =>
                                            setContactEdit({ ...contactEdit, phone: e.target.value })
                                        }

                                    />

                                    {inputError && (!contactEdit?.phone || !validatePhone(contactEdit?.phone)) && (
                                        <span className="text-danger">Enter phone in xxx-xxx-xxxx format</span>
                                    )}



                                </div>
                                <div className="col-2 my-3">
                                    <label htmlFor="fax">Contact Fax</label>

                                    <input name="fax" id="fax" type="text" className="form-control"
                                        value={contactEdit?.fax}
                                        onChange={(e) =>
                                            setContactEdit({ ...contactEdit, fax: e.target.value })
                                        }

                                    />

                                    {inputError && contactEdit?.fax && !validatePhone(contactEdit?.fax) && (
                                        <span className="text-danger">Enter fax in xxx-xxx-xxxx format</span>
                                    )}


                                </div>

                                <div className="col-2 my-3">
                                    <label htmlFor="email_opt_in" >Contact Email Opt-In</label>
                                    <div className="form-control py-2 border-2 border-dark">

                                        <input type="radio" className="form-check-input " name="email_opt_in" value="1"
                                            onClick={() => setContactEdit({ ...contactEdit, email_opt_in: 1 })} checked={(contactEdit?.email_opt_in == 1) ? "true" : ""} /> Yes
                                        <input type="radio" className="form-check-input ms-3" name="email_opt_in" value="0"
                                            onClick={() => setContactEdit({ ...contactEdit, email_opt_in: 0 })} checked={(contactEdit?.email_opt_in == 0) ? "true" : ""} /> No

                                    </div>
                                </div>

                            </div>
                        }
                        {(contactsList) &&
                            <>

                                <div className="row px-3 py-2 gx-2 ">
                                    <div className="col-1">
                                        <label className="control-label">Action</label>
                                    </div>
                                    <div className="col-2">
                                        <label className="control-label">Name:</label>
                                    </div>
                                    <div className="col-3">
                                        <label className="control-label">Email</label>
                                    </div>
                                    <div className="col-2">
                                        <label className="control-label">Phone</label>
                                    </div>
                                    <div className="col-2">
                                        <label className="control-label">Fax</label>
                                    </div>

                                    <div className="col-1">
                                        <label className="control-label">E-Opt-in</label>
                                    </div>
                                    <div className="col-1">
                                        <label className="control-label">Status</label>
                                    </div>


                                </div>

                                {contactsList.map((p, index) => {
                                    return (
                                        <div className="row px-3 py-2 gx-2 ">
                                            <div className="col-1">

                                                <button type="button" className="btn btn-sm btn-sm btn-warning me-1" onClick={() => { editContact(p) }} ><FaPen title="Edit" /></button>
                                                {p.status == 1 ?
                                                    <button type="button" className="btn btn-sm btn-sm btn-danger me-1" onClick={() => { deactivateContact(p.id) }} ><FaTrash title="Deactivate" /></button>
                                                    :
                                                    <button type="button" className="btn btn-sm btn-sm btn-success me-1" onClick={() => { activateContact(p.id) }} ><FaThumbsUp title="Activate" /></button>

                                                }




                                            </div>
                                            <div className="col-2">
                                                <label className="field-info" >{p?.first_name + " " + p?.last_name}</label>
                                            </div>
                                            <div className="col-3">
                                                <label className="field-info tt-none" >{p?.email}</label>
                                            </div>
                                            <div className="col-2">
                                                <label className="field-info" >{p?.phone}</label>
                                            </div>
                                            <div className="col-2">
                                                <label className="field-info" >{p?.fax}</label>
                                            </div>

                                            <div className="col-1">
                                                <label className="field-info" >{p?.email_opt_in == 1 ? "YES" : "NO"}</label>
                                            </div>

                                            <div className="col-1">
                                                <label className="field-info" >{p?.status == 1 ? "Active" : "Blocked"}</label>
                                            </div>

                                        </div>
                                    )
                                })}




                            </>

                        }
                    </div>
                </div>

            }
            {isLoading ?

                <ReactLoading type={"cylon"} color={"#E4F0FD"} height={250} width={250} />
                :
                <>

                    {clients &&
                        <>
                            <div className="card card-form card-primary  h-100 mx-3" >
                                <div className="card-body p-0 mb-5" >


                                    <PrimaryTable columns={columns} data={clients} />
                                </div></div>
                        </>
                    }
                </>
            }

            <Modal animation={false}
                show={editClientModalOpen}
                onHide={() => { setEditClientModalOpen(false); }}
                keyboard={false}
                backdrop="static"
                id="search-client-modal"
                size="lg"
            >
                <Modal.Header><h3 className="m-0 p-0">UPDATE CLIENT</h3></Modal.Header>
                <Modal.Body>
                    <div className="modal-inner-content form-thick">


                        {isLoading ?
                            <div className="text-center m-auto loader" >
                                <ReactLoading type={"cylon"} color={"#54418B"} height={250} width={250} />
                            </div>
                            :



                            <>


                                <div className="row px-3 py-2 gx-2">

                                    <div className="col-3 mb-2">
                                        <label htmlFor="client_company_name" >Company Name*</label>

                                        <input name="client_company_name" className="form-control" type="text"
                                            value={clientEdit?.client_company_name}
                                            onChange={(e) =>
                                                setClientEdit({ ...clientEdit, client_company_name: e.target.value })
                                            }


                                        />

                                        {inputError && !clientEdit?.client_company_name &&
                                            <span className="text-danger">Enter company Name</span>
                                        }

                                    </div>

                                    <div className="col-3 mb-2">
                                        <label htmlFor="client_address">ADDRESS*</label>
                                        <input name="client_address" id="client_address" type="text" className="form-control"
                                            value={clientEdit?.client_address}
                                            onChange={(e) =>
                                                setClientEdit({ ...clientEdit, client_address: e.target.value })
                                            }

                                        />
                                        {inputError && !clientEdit?.client_address &&
                                            <span className="text-danger">Enter address</span>
                                        }


                                    </div>

                                    <div className="col-3 mb-2">
                                        <label htmlFor="client_city">CITY*</label>

                                        <input name="client_city" id="client_city" type="text" className="form-control"
                                            value={clientEdit?.client_city}
                                            onChange={(e) =>
                                                setClientEdit({ ...clientEdit, client_city: e.target.value })
                                            }

                                        />

                                        {inputError && !clientEdit?.client_city &&
                                            <span className="text-danger">Enter city</span>
                                        }

                                    </div>

                                    <div className="col-3 mb-2">
                                        <div className="row gx-2">

                                            <div className="col-6">
                                                <label htmlFor="client_state">STATE*</label>

                                                <input name="client_state" id="client_state" type="text"
                                                    className="form-control"
                                                    value={clientEdit?.client_state} onChange={(e) =>
                                                        setClientEdit({ ...clientEdit, client_state: e.target.value })
                                                    }
                                                />
                                                {inputError && !clientEdit?.client_state &&
                                                    <span className="text-danger">Enter state</span>
                                                }

                                            </div>
                                            <div className="col-6">


                                                <label htmlFor="client_zip">ZIP*</label>

                                                <input name="client_zip" id="client_zip" type="text"
                                                    className="form-control"
                                                    value={clientEdit?.client_zip} onChange={(e) =>
                                                        setClientEdit({ ...clientEdit, client_zip: e.target.value })
                                                    }
                                                />

                                                {inputError && !clientEdit?.client_zip &&
                                                    <span className="text-danger">Enter zip</span>
                                                }
                                            </div>
                                        </div>
                                    </div>


                                </div>

                                <div className="row px-3 py-2 gx-2">

                                    <div className="col-3 mb-2">
                                        <label htmlFor="client_fee_limit">FEE LIMIT:(dd.cc)$</label>

                                        <input name="client_fee_limit" id="client_fee_limit" type="text" className="form-control"
                                            value={clientEdit?.client_fee_limit} onChange={(e) =>
                                                setClientEdit({ ...clientEdit, client_fee_limit: e.target.value })
                                            }

                                        />

                                        {inputError && !validateAmount(clientEdit?.client_fee_limit) && (
                                            <span className="text-danger">Enter valid fee limit</span>
                                        )}


                                    </div>

                                    <div className="col-3 mb-2">
                                        <label htmlFor="client_fee">CLIENT FEE:(dd.cc)$</label>

                                        <input name="client_fee" id="client_fee" type="text" className="form-control"
                                            value={clientEdit?.client_fee} onChange={(e) =>
                                                setClientEdit({ ...clientEdit, client_fee: e.target.value })
                                            }

                                        />

                                        {inputError && !validateAmount(clientEdit?.client_fee) && (
                                            <span className="text-danger">Enter valid fee</span>
                                        )}

                                    </div>

                                    <div className="col-3">
                                        <label htmlFor="email_opt_in">Email Opt-In</label>
                                        <div className="form-control border-2 border-dark">

                                            <input type="radio" className="form-check-input " name="email_opt_in" value="1"
                                                onClick={() => setClientEdit({ ...clientEdit, email_opt_in: 1 })} checked={(clientEdit?.email_opt_in == 1) ? "true" : ""} /> Yes
                                            <input type="radio" className="form-check-input ms-3" name="email_opt_in" value="0"
                                                onClick={() => setClientEdit({ ...clientEdit, email_opt_in: 0 })} checked={(clientEdit?.email_opt_in == 0) ? "true" : ""} /> No

                                        </div>
                                    </div>

                                    <div className="col-3">
                                        <label htmlFor="email_opt_in">STATUS ACTIVE</label>
                                        <div className="form-control border-2 border-dark">

                                            <input type="radio" className="form-check-input " name="status" value="1"
                                                onClick={() => setClientEdit({ ...clientEdit, status: 1 })} checked={(clientEdit?.status == 1) ? "true" : ""} /> Yes
                                            <input type="radio" className="form-check-input ms-3" name="email_opt_in" value="0"
                                                onClick={() => setClientEdit({ ...clientEdit, status: 0 })} checked={(clientEdit?.status != 1) ? "true" : ""} /> No

                                        </div>
                                    </div>


                                    <div className="col-8">
                                        <label htmlFor="client_internal_notes">INTERNAL NOTES</label>

                                        <textarea rows="1" name="client_internal_notes" id="client_internal_notes"
                                            className="form-control"
                                            onChange={(e) =>
                                                setClientEdit({ ...clientEdit, client_internal_notes: e.target.value })
                                            }
                                            value={clientEdit?.client_internal_notes}

                                        >
                                            {clientEdit?.client_internal_notes}
                                        </textarea>

                                    </div>
                                    <div className="col-4">
                                        <label htmlFor="client_receipt_type">Receipt Type</label>
                                        <div className="form-control  border-2 border-dark">

                                            <input type="radio" className="form-check-input" name="client_receipt_type" value="1"
                                                onClick={() => setClientEdit({ ...clientEdit, client_receipt_type: 1 })} checked={(clientEdit?.client_receipt_type == 1) ? "true" : ""} /> Ledger
                                            <input type="radio" className="form-check-input ms-3" name="client_receipt_type" value="0"
                                                onClick={() => setClientEdit({ ...clientEdit, client_receipt_type: 0 })} checked={(clientEdit?.client_receipt_type == 0) ? "true" : ""} /> Invoice
                                        </div>

                                    </div>





                                </div>



                            </>
                        }

                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <div className="container-fluid ">
                        <div className=" text-center">
                            <button type='button' onClick={() => updateClient()} className="btn  btn-success mx-1 " disabled={isBtn}>
                                {isBtn ? <><div className="spinner-border spinner-border-sm me-1" role="status">

                                </div><span className="sr-only">Loading...</span></> : 'UPDATE CLIENT'}
                            </button>
                            <button type='button' className="btn  btn-warning" onClick={(e) => setEditClientModalOpen(false)}  >CANCEL UPDATE</button>
                        </div>
                    </div>
                </Modal.Footer>
            </Modal>


            <Modal show={lorModalOpen} onHide={() => { setLORModalOpen(false); setLORFile(null); }} backdrop="static" keyboard={false} >
                <Modal.Header closeButton>
                    <Modal.Title>LOR Attachment</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <div className="mb-3">
                        <label className="form-label">Upload LOR (PDF)</label>
                        <input type="file" accept="application/pdf" className="form-control" onChange={(e) => setLORFile(e.target.files[0])}  />
                    </div>

                   {(currentClientLOR) &&
                    <div className="d-flex gap-2">
                        <a className="btn btn-sm btn-success" href={process.env.REACT_APP_WEB_SERVICES_URL + "/admin/download-lor/" + currentClientId} target="_blank"  >
                            Download
                        </a>

                        <button className="btn btn-sm btn-danger" onClick={removeLOR} disabled={isBtn} >
                            Remove
                        </button>
                    </div>
}
                </Modal.Body>

                <Modal.Footer>
                    <button className="btn btn-success" disabled={isBtn} onClick={() => uploadLOR(currentClientId)} >
                        {isBtn ? "Uploading..." : "Upload"}
                    </button>

                    <button className="btn btn-warning" onClick={() => { setLORModalOpen(false); setLORFile(null); }} >Close</button>
                </Modal.Footer>
            </Modal>


        </>

    );
};

export default Clients;